"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectInitialCards = void 0;
var vue_1 = require("vue");
var Button_1 = require("./common/Button");
var CardFinder_1 = require("../CardFinder");
var CardName_1 = require("../CardName");
var constants = require("../constants");
var SelectCard_1 = require("./SelectCard");
var ConfirmDialog_1 = require("./common/ConfirmDialog");
var PreferencesManager_1 = require("./PreferencesManager");
exports.SelectInitialCards = vue_1.default.component('select-initial-cards', {
    props: {
        player: {
            type: Object,
        },
        playerinput: {
            type: Object,
        },
        onsave: {
            type: Function,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    components: {
        Button: Button_1.Button,
        'select-card': SelectCard_1.SelectCard,
        'confirm-dialog': ConfirmDialog_1.ConfirmDialog,
    },
    data: function () {
        return {
            selectedCards: [],
            selectedCorporation: undefined,
            selectedPrelude: [],
        };
    },
    methods: {
        getAfterPreludes: function () {
            var _a;
            var result = 0;
            for (var _i = 0, _b = this.selectedPrelude; _i < _b.length; _i++) {
                var prelude = _b[_i];
                switch (prelude) {
                    case CardName_1.CardName.ALLIED_BANKS:
                        result += 3;
                        break;
                    case CardName_1.CardName.BUSINESS_EMPIRE:
                        result -= 6;
                        break;
                    case CardName_1.CardName.AQUIFER_TURBINES:
                        result -= 3;
                        break;
                    case CardName_1.CardName.HUGE_ASTEROID:
                        result -= 5;
                        break;
                    case CardName_1.CardName.HUGE_ASTEROID_REBALANCED:
                        result -= 2;
                        break;
                    case CardName_1.CardName.DONATION:
                        result += 21;
                        break;
                    case CardName_1.CardName.DONATION_REBALANCED:
                        result += 23;
                        break;
                    case CardName_1.CardName.GALILEAN_MINING:
                        result -= 5;
                        break;
                    case CardName_1.CardName.LOAN:
                        result += 30;
                        break;
                    case CardName_1.CardName.LOAN_REBALANCED:
                        result += 32;
                        break;
                    case CardName_1.CardName.METALS_COMPANY_REBALANCED:
                        result += 2;
                        break;
                    case CardName_1.CardName.POLAR_INDUSTRIES_REBALANCED:
                        result += 5;
                        break;
                    case CardName_1.CardName.SOCIETY_SUPPORT_REBALANCED:
                        result -= 3;
                        break;
                    case CardName_1.CardName.SELF_SUFFICIENT_SETTLEMENT_REBALANCED:
                        result += 3;
                        break;
                    case CardName_1.CardName.NITROGEN_SHIPMENT:
                        result += 5;
                        break;
                    case CardName_1.CardName.MARTIAN_INDUSTRIES:
                    case CardName_1.CardName.MARTIAN_INDUSTRIES_REBALANCED:
                    case CardName_1.CardName.VALUABLE_GASES:
                        result += 6;
                        break;
                    case CardName_1.CardName.AEROSPACE_MISSION:
                        result -= 14;
                        break;
                    case CardName_1.CardName.RESEARCH_GRANT:
                        result += 8;
                        break;
                    case CardName_1.CardName.TRADE_ADVANCE:
                        result += 2;
                        break;
                }
                switch ((_a = this.selectedCorporation) === null || _a === void 0 ? void 0 : _a.name) {
                    case CardName_1.CardName.MANUTECH:
                        switch (prelude) {
                            case CardName_1.CardName.ALLIED_BANKS:
                                result += 4;
                                break;
                            case CardName_1.CardName.BUSINESS_EMPIRE:
                                result += 6;
                                break;
                            case CardName_1.CardName.DOME_FARMING:
                            case CardName_1.CardName.SELF_SUFFICIENT_SETTLEMENT:
                            case CardName_1.CardName.SELF_SUFFICIENT_SETTLEMENT_REBALANCED:
                                result += 2;
                                break;
                            case CardName_1.CardName.METALS_COMPANY:
                            case CardName_1.CardName.RESEARCH_NETWORK:
                            case CardName_1.CardName.BIOSPHERE_SUPPORT:
                                result += 1;
                                break;
                        }
                        break;
                    case CardName_1.CardName.THARSIS_REPUBLIC:
                        switch (prelude) {
                            case CardName_1.CardName.SELF_SUFFICIENT_SETTLEMENT:
                            case CardName_1.CardName.SELF_SUFFICIENT_SETTLEMENT_REBALANCED:
                            case CardName_1.CardName.EARLY_SETTLEMENT:
                            case CardName_1.CardName.EARLY_SETTLEMENT_REBALANCED:
                                result += 3;
                                break;
                        }
                        break;
                    case CardName_1.CardName.PHARMACY_UNION:
                        switch (prelude) {
                            case CardName_1.CardName.BIOFUELS:
                            case CardName_1.CardName.BIOFUELS_REBALANCED:
                            case CardName_1.CardName.ECOLOGY_EXPERTS:
                                result -= 4;
                                break;
                        }
                        break;
                    case CardName_1.CardName.SPLICE:
                        switch (prelude) {
                            case CardName_1.CardName.BIOFUELS:
                            case CardName_1.CardName.BIOFUELS_REBALANCED:
                            case CardName_1.CardName.ECOLOGY_EXPERTS:
                                result += 2;
                                break;
                        }
                        break;
                    case CardName_1.CardName.APHRODITE:
                        switch (prelude) {
                            case CardName_1.CardName.VENUS_FIRST:
                                result += 4;
                                break;
                        }
                    case CardName_1.CardName.APHRODITE_REBALANCED:
                        switch (prelude) {
                            case CardName_1.CardName.VENUS_FIRST:
                                result += 10;
                                break;
                        }
                }
            }
            return result;
        },
        getOption: function (idx) {
            if (this.playerinput.options === undefined || this.playerinput.options[idx] === undefined) {
                throw new Error('invalid input, missing option');
            }
            return this.playerinput.options[idx];
        },
        getStartingMegacredits: function () {
            if (this.selectedCorporation === undefined) {
                return NaN;
            }
            var starting = this.selectedCorporation.startingMegaCredits;
            var cardCost = this.selectedCorporation.cardCost === undefined ? constants.CARD_COST : this.selectedCorporation.cardCost;
            starting -= this.selectedCards.length * cardCost;
            return starting;
        },
        saveIfConfirmed: function () {
            if (PreferencesManager_1.PreferencesManager.load('show_alerts') === '1' && this.selectedCards.length === 0) {
                this.$refs['confirmation'].show();
            }
            else {
                this.saveData();
            }
        },
        saveData: function () {
            var result = [];
            result.push([]);
            if (this.selectedCorporation !== undefined) {
                result[0].push(this.selectedCorporation.name);
            }
            if (this.hasPrelude()) {
                result.push(this.selectedPrelude);
            }
            result.push(this.selectedCards);
            this.onsave(result);
        },
        hasPrelude: function () {
            return this.playerinput.options !== undefined && this.playerinput.options.length === 3;
        },
        cardsChanged: function (cards) {
            this.selectedCards = cards;
        },
        corporationChanged: function (cards) {
            this.selectedCorporation = new CardFinder_1.CardFinder().getCorporationCardByName(cards[0]);
        },
        preludesChanged: function (cards) {
            this.selectedPrelude = cards;
        },
        confirmSelection: function () {
            this.saveData();
        },
    },
    template: "\n  <div class=\"select-initial-cards\">\n    <confirm-dialog\n      message=\"Continue without buying initial cards?\"\n      ref=\"confirmation\"\n      v-on:accept=\"confirmSelection\" />\n    <select-card :player=\"player\" :playerinput=\"getOption(0)\" :showtitle=\"true\" v-on:cardschanged=\"corporationChanged\" />\n    <select-card v-if=\"hasPrelude()\" :player=\"player\" :playerinput=\"getOption(1)\" :showtitle=\"true\" v-on:cardschanged=\"preludesChanged\" />\n    <select-card :player=\"player\" :playerinput=\"getOption(hasPrelude() ? 2 : 1)\" :showtitle=\"true\" v-on:cardschanged=\"cardsChanged\" />\n    <div v-if=\"selectedCorporation\" v-i18n>Starting Megacredits: <div class=\"megacredits\">{{getStartingMegacredits()}}</div></div>\n    <div v-if=\"selectedCorporation && hasPrelude()\" v-i18n>After Preludes: <div class=\"megacredits\">{{getStartingMegacredits() + getAfterPreludes()}}</div></div>\n    <Button v-if=\"showsave\" :onClick=\"saveIfConfirmed\" type=\"submit\" :title=\"playerinput.buttonLabel\" />\n  </div>",
});
//# sourceMappingURL=SelectInitialCards.js.map